import React from 'react'
import PropTypes from 'prop-types'
import ErrorComponent from 'components/Errors/ErrorComponent'
import LoadingIndicator from 'components/LoadingIndicator'

/**
 * 1) Prints error message if error
 * 2) Prints loading indicator if loading
 * 3) Prints the content eg. children when loading is done
 */
const Loading = ({ children, loading, loadingProps = {}, error = false, errorProps = {} }) => (
    error
        ? <ErrorComponent error={error} {...errorProps} />
        : loading
            ? <LoadingIndicator {...loadingProps} />
            : children ? children() : null
)

Loading.propTypes = {
    children: PropTypes.func,
    loading: PropTypes.bool.isRequired,
    error: PropTypes.any,
    loadingProps: PropTypes.object,
    errorProps: PropTypes.object,
}

export default Loading

/**
 * Just like Loading, but just pass Apollo query/mutation data instead of loading and error separately.
 */
export const DataLoading = ({ data, loading, error, ...rest }) => (
    <Loading loading={!!(data.loading || loading)} error={data.error || error} {...rest} />
)

DataLoading.propTypes = {
    children: PropTypes.func,
    data: PropTypes.shape({
        loading: PropTypes.bool.isRequired,
        error: PropTypes.any,
    }).isRequired,
}
